import React from "react";
import { useContext } from "react";
import { LeadData } from "./VayuLead";
import VayuHeader from "./VayuHeader";
import VayuContent from "./VayuContent";
import ProfilePlaceHolder from "modules/dashboards/home/ProfilePlaceHolder";

function ShowWayuLead() {
  const { doc, leadLoading } = useContext(LeadData);

  return leadLoading ? (
    <ProfilePlaceHolder />
  ) : (
    <div style={{ height: "100%" }} key={doc}>
      <VayuHeader />
      <div
        style={{
          height: "67vh",
          overflow: "scroll",
        }}
        className="scrollable-container"
      >
        <VayuContent />
      </div>
    </div>
  );
}

export default ShowWayuLead;
